import { SingleSignOnDetectionDomainsWithCustomProviderMap } from "../../configuration.json";

export const getFederatedSignInCustomProvider = (email) => {
  return SingleSignOnDetectionDomainsWithCustomProviderMap[
    Object.keys(SingleSignOnDetectionDomainsWithCustomProviderMap).find((eachDomain) => {
      return new RegExp(`[a-zA-Z0-9+]*@${eachDomain}$`).test(email);
    })
  ];
};
